import axios from "axios";
import { AuthService } from "../services/AuthService";
import { UserService } from "../services/UserService";
import { HmacSignatureUtilities } from "../services/hmac-encryption-decryption";
import CryptoJS from "crypto-js";
import Config from "../config";
import { getClientInfoAxiosHeaders, initClientInfo } from "../services/ClientInfoService";

export const AxiosInstance = axios.create();

// void initClientInfo();

// Attaches X-Device-Type, X-Surface, X-App-Version, X-Host-Client (from ClientInfoService).
const applyClientInfoHeaders = (req) => {
    const clientHeaders = getClientInfoAxiosHeaders();
    Object.assign(req.headers, clientHeaders);
};

AxiosInstance.interceptors.request.use(
    req => {
        applyClientInfoHeaders(req);

        var isTokenExpired = AuthService.isTokenExpired();

        if (isTokenExpired && req.method !== "OPTIONS") {
            return AuthService.refreshToken().then(res => {
                req.headers.authorization = `Bearer ${AuthService.getToken().access_token}`;
                applyClientInfoHeaders(req);
                return Promise.resolve(req);
            }).catch(err => {
                console.log(err);
                if (!AuthService.isLogoutInProgress()) {
                    AuthService.logout().then(() => {
                        AuthService.clearSession();
                    }).catch(() => {
                        AuthService.clearSession();
                    });
                }
            });
        } else {
            var token = AuthService.getToken();
            const SecureDataConnection =  req.url.includes("securefileshare")
            if (!!token && !!token.access_token && req.method !== "OPTIONS")
                req.headers.authorization = `Bearer ${token.access_token}`;
            if (!!localStorage.getItem("current-user") && !!UserService.getUserPhoneNumber() && !!UserService.getUserPhoneNumberId() && !SecureDataConnection) {                                
                req.headers.PhoneNumber = req.url.includes("secureChat") ? CryptoJS.AES.encrypt(UserService.getUserPhoneNumber(), Config.SECURE_HMAC_SECRET_KEY).toString():UserService.getUserPhoneNumber()
                req.headers.PhoneNumberId = UserService.getUserPhoneNumberId()
            }                                                                                                                                                                                                                                                                                                                                                                                                                     
            if ((req.url.includes("secureChat") || req.url.includes("securefileshare")) && !!req.data) {
                req.headers.FalkonSignature = HmacSignatureUtilities.signData(req.data)
            }
            return req;
        }
    },
    error => {
        return Promise.reject(error);
    }
);

AxiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.log(error);

        if (error && error.response && (error.response.status === 401 || error.response.status === 403)) {
            if (!AuthService.isLogoutInProgress()) {
                AuthService.logout().then(() => {
                    AuthService.clearSession();
                }).catch(() => {
                    AuthService.clearSession();
                });
            }
        }

        return Promise.reject(error);
    }
);
